 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import LOVE_1 from '@/components/love_1'
 import TEXTCHAP225799 from '@/components/Text/chap225799'
 import TEXTCHAP225776 from '@/components/Text/chap225776'
 import TEXTCHAP225769 from '@/components/Text/chap225769'
 import TEXTCHAP225768 from '@/components/Text/chap225768'
 import TEXTCHAP225780 from '@/components/Text/chap225780'
 import TEXTCHAP225778 from '@/components/Text/chap225778'
 import TEXTCHAP225801 from '@/components/Text/chap225801'
 import TEXTCHAP225803 from '@/components/Text/chap225803'
 import TEXTCHAP225805 from '@/components/Text/chap225805'
 import TEXTCHAP225796 from '@/components/Text/chap225796'
 import TEXTCHAP225750 from '@/components/Text/chap225750'
 import TEXTCHAP225797 from '@/components/Text/chap225797'
 import TEXTCHAP225806 from '@/components/Text/chap225806'
 import TEXTCHAP225781 from '@/components/Text/chap225781'
 import TEXTCHAP225794 from '@/components/Text/chap225794'
 import TEXTCHAP225775 from '@/components/Text/chap225775'
 import TEXTCHAP225754 from '@/components/Text/chap225754'
 import TEXTCHAP225751 from '@/components/Text/chap225751'
 import TEXTCHAP225798 from '@/components/Text/chap225798'
 import TEXTCHAP225758 from '@/components/Text/chap225758'
 import TEXTCHAP225788 from '@/components/Text/chap225788'
 import TEXTCHAP225789 from '@/components/Text/chap225789'
 import TEXTCHAP225807 from '@/components/Text/chap225807'
 import TEXTCHAP225786 from '@/components/Text/chap225786'
 import TEXTCHAP225791 from '@/components/Text/chap225791'
 import TEXTCHAP225761 from '@/components/Text/chap225761'
 import TEXTCHAP225793 from '@/components/Text/chap225793'
 import TEXTCHAP225770 from '@/components/Text/chap225770'
 import TEXTCHAP225804 from '@/components/Text/chap225804'
 import TEXTCHAP225787 from '@/components/Text/chap225787'
 import TEXTCHAP225784 from '@/components/Text/chap225784'
 import TEXTCHAP225772 from '@/components/Text/chap225772'
 import TEXTCHAP225767 from '@/components/Text/chap225767'
 import TEXTCHAP225800 from '@/components/Text/chap225800'
 import TEXTCHAP225783 from '@/components/Text/chap225783'
 import TEXTCHAP225756 from '@/components/Text/chap225756'
 import TEXTCHAP225746 from '@/components/Text/chap225746'
 import TEXTCHAP225752 from '@/components/Text/chap225752'
 import TEXTCHAP225760 from '@/components/Text/chap225760'
 import TEXTCHAP225747 from '@/components/Text/chap225747'
 import TEXTCHAP225771 from '@/components/Text/chap225771'
 import TEXTCHAP225759 from '@/components/Text/chap225759'
 import TEXTCHAP225766 from '@/components/Text/chap225766'
 import TEXTCHAP225749 from '@/components/Text/chap225749'
 import TEXTCHAP225745 from '@/components/Text/chap225745'
 import TEXTCHAP225792 from '@/components/Text/chap225792'
 import TEXTCHAP225785 from '@/components/Text/chap225785'
 import TEXTCHAP225764 from '@/components/Text/chap225764'
 import TEXTCHAP225748 from '@/components/Text/chap225748'
 import TEXTCHAP225765 from '@/components/Text/chap225765'
 import TEXTCHAP225790 from '@/components/Text/chap225790'
 import TEXTCHAP225795 from '@/components/Text/chap225795'
 import TEXTCHAP225774 from '@/components/Text/chap225774'
 import TEXTCHAP225762 from '@/components/Text/chap225762'
 import TEXTCHAP225782 from '@/components/Text/chap225782'
 import TEXTCHAP225755 from '@/components/Text/chap225755'
 import TEXTCHAP225779 from '@/components/Text/chap225779'
 import TEXTCHAP225763 from '@/components/Text/chap225763'
 import TEXTCHAP225753 from '@/components/Text/chap225753'
 import TEXTCHAP225757 from '@/components/Text/chap225757'
 import TEXTCHAP225802 from '@/components/Text/chap225802'
 import TEXTCHAP225773 from '@/components/Text/chap225773'
 import LOVE_2 from '@/components/love_2'
 import TEXTCHAP225777 from '@/components/Text/chap225777'
 import TEXTCHAP225808 from '@/components/Text/chap225808'
 import TEXTCHAP225809 from '@/components/Text/chap225809'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/title_page",
 			"name" : "Text/title_page",
 			"component" : TEXTTITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/chap225799",
 			"name" : "Text/chap225799",
 			"component" : TEXTCHAP225799
 		},
 		{
 			"path" : "/Text/chap225776",
 			"name" : "Text/chap225776",
 			"component" : TEXTCHAP225776
 		},
 		{
 			"path" : "/Text/chap225769",
 			"name" : "Text/chap225769",
 			"component" : TEXTCHAP225769
 		},
 		{
 			"path" : "/Text/chap225768",
 			"name" : "Text/chap225768",
 			"component" : TEXTCHAP225768
 		},
 		{
 			"path" : "/Text/chap225780",
 			"name" : "Text/chap225780",
 			"component" : TEXTCHAP225780
 		},
 		{
 			"path" : "/Text/chap225778",
 			"name" : "Text/chap225778",
 			"component" : TEXTCHAP225778
 		},
 		{
 			"path" : "/Text/chap225801",
 			"name" : "Text/chap225801",
 			"component" : TEXTCHAP225801
 		},
 		{
 			"path" : "/Text/chap225803",
 			"name" : "Text/chap225803",
 			"component" : TEXTCHAP225803
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js